export default __webpack_public_path__ + "static/media/oldBuildings.89d120cc.jpeg";